module.exports = __webpack_public_path__ + "img/duigong.1f711ea5.jpg";